__webpack_require__.p = "/heads-up-texas-holdem/";